"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ssRouterContractAddress = void 0;
exports.ssRouterContractAddress = '0x6a1e73f12018d8e5f966ce794aa2921941feb17e';
